import React from 'react';

import gql from 'graphql-tag';
import PropTypes from 'prop-types';
import { Mutation } from 'react-apollo';

import ErrorModal from '../ErrorModal';
import MutationRequest from '../MutationRequest';

export const CREATE_TAG = gql`
  mutation CREATE_TAG($projectId: String!, $tagName: String!) {
    tagMutation {
      addTagInProject(projectId: $projectId, tagName: $tagName) {
        id
        name
      }
    }
  }
`;

const CreateProjectTag = ({ projectId, tagName, onError, onSuccessResult }) => (
  <Mutation mutation={CREATE_TAG}>
    {(createTag, { loading, error, data }) => {
      const variables = {
        projectId,
        tagName,
      };

      if (error) {
        return <ErrorModal error={error} onError={onError} />;
      }
      if (data) {
        onSuccessResult(data.tagMutation.addTagInProject);
      }

      return (
        <MutationRequest
          isLoading={loading}
          mutation={createTag}
          variables={variables}
        />
      );
    }}
  </Mutation>
);

CreateProjectTag.propTypes = {
  onError: PropTypes.func.isRequired,
  onSuccessResult: PropTypes.func.isRequired,
  projectId: PropTypes.string.isRequired,
  tagName: PropTypes.string.isRequired,
};

export default CreateProjectTag;
